import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "counter"]
  static values = { limit: Number, message: String, counter: String }

  connect() {
    this.update()
  }

  update() {
    const occupied = field => field.value.trim() !== "" || field.dataset.otherLanguagePresent === "true"
    const count = this.fieldTargets.filter(occupied).length
    this.counterTarget.textContent = this.counterValue.replace("%{count}", count).replace("%{limit}", this.limitValue)
    this.counterTarget.classList.toggle("text-danger", count > this.limitValue)
    this.fieldTargets.forEach(field => {
      // Readonly preserves blank values in the submission, including fields the user cleared.
      field.readOnly = count >= this.limitValue && !occupied(field)
      field.setCustomValidity("")
    })
    if (count > this.limitValue) this.fieldTargets.find(occupied)?.setCustomValidity(this.messageValue)
  }

  validate(event) {
    this.update()
    if (!this.element.checkValidity()) {
      event.preventDefault()
      this.element.reportValidity()
    }
  }
}
